import {
  OnClickMapPin,
  OnHideMap,
  OnShowMap
} from './map.types'

export const CLICK_MAP_PIN = 'CLICK_MAP_PIN'
export const HIDE_MAP = 'HIDE_MAP'
export const SHOW_MAP = 'SHOW_MAP'

export const onClickMapPin: OnClickMapPin = (productId, productName) => ({
  payload: {
    productId,
    productName
  },
  type: CLICK_MAP_PIN
})

export const onHideMap: OnHideMap = () => ({
  type: HIDE_MAP
})

export const onShowMap: OnShowMap = (variant) => ({
  payload: {
    variant
  },
  type: SHOW_MAP
})
